// Author: Luis Booth - September 2018
//
// Validations:
//     - Luis Booth
//     - Conary Hernandez
//
// Thank you Mario!
// But our princess is in another castle!
//                   _   |~  _
//                  [_]--'--[_]
//                  |'|""`""|'|
//                  | | /^\ | |
//                  |_|_|I|_|_|
//
//   ▄████▄▄░
//   ▄▀█▀▐└─┐░░
//   █▄▐▌▄█▄┘██
//   └▄▄▄▄▄┘███
//   ██▒█▒███▀

import React, { Component } from 'react';
import validator from 'js/modules/validator';
import validationEngine from 'js/modules/validationEngine';
import DataService from 'js/modules/dataservice';
// import constants from 'js/modules/constants';
// import moment from 'moment';
// import DataService from 'js/modules/dataservice';
import { roundNumber } from 'js/modules/utils';
import cm from 'js/modules/cm';
import moment from 'moment';
import { createSessionExpiredCookie, sessionExpiredCookie } from '../global/AccountsExpirationSessionCookie';

const state = {
  totalBooking: 3456,
  countries: [],
  summaryResponse: {
    roomData: {},
  },
  summaryLoaded: false,
  ssgCredentials: {
    username: '',
    password: '',
    recaptchaToken: '',
  },
  ssgResponse: { code: -1 },
  ssgMemberInfo: {},
  ssgPointsToUse: 0,
  ssgPointsType: 'none',
  fields: {
    termsConditions: false,
  },
  recoverySSGCredentials: {
    username_recovery: '',
    email_recovery: '',
  },
  fieldValidations: {
    termsConditions: true,
  },
  isModalOpen: {
    applyPoints: false,
    cvv: false,
    forgotPassword: false,
    terms: false,
    protectionPlan: false,
  },
  layawayResponse: {},
  hasInsurance: 'false',
  isPassword: false,
  recoverySSGResponse: {
    code: -1,
  },
  maxApplyPoints: '',
  appliedOffer: false, // flash sale
  appliedPoinst: 0,
  appliesPointsOffer: false,
  warning: false,
  repeatedCard: false,
  ccId: '1',
  showLoader: false,
  submitSSGAttemps: 0,
  showRecaptcha: false,
  isForgotPassword: false,
  isLogin: true,
  isLogged: false,
  validTotalAmount: true,
  travelInsurancePrice: 0,
  finalBookingPrice: 0,
  finalHoldOption: 0,
  priceToPay: 0,
  minAmountPerCard: 98,
  totalCards: 'oneCard',
  enabledAmountField: false,
  disabled: 'on',
  tppOptionSelected: false, // Travel Protection Plan option selected.
  tppRequiredWarning: false,
  upliftWasSelected: false,
  upliftStatus: false,
  canApplyPointsWithAccounts: false,
  isLoggedAccounts: false,
  accountProfileInformation: {},
  accountPassword: '',
  invalidAccounstPassword: false,
  accountLoading: false,
};

const PaymentContext = React.createContext({
  state: {...state},

  // Tests
  closeModal() {},
  setInputValue() {},
});

// Payment
const validationRules = {
  // acceptLayaway: [],
  otherAmount: ['amount'],
  paymentOption: ['required'],
  layawayPlanOption: ['alphaNumeric'],
  amount_1: ['required', 'amount'],
  cardHolder_1: ['required', 'ccName'],
  cardType_1: [],
  cardNumber_1: ['required', 'ccNumber'],
  expirationMonth_1: ['required'],
  expirationYear_1: ['required'],
  CVV_1: ['required', 'cvv'],
  streetAddress_1: ['address', 'required'],
  streetAddress2_1: ['address'],
  streetAddress_2: ['address'],
  streetAddress2_2: ['address'],
  city_1: ['required', 'name'],
  country_1: ['required', 'name'],
  state_1: ['name'],
  zipCode_1: ['alphaNumeric'],
  phone_1: ['required', 'phone'],
  amount_2: ['amount'],
  cardHolder_2: ['ccName'],
  cardNumber_2: [],
  cardType_2: [],
  expirationMonth_2: [],
  expirationYear_2: [],
  CVV_2: ['cvv'],
  city_2: ['name'],
  country_2: ['name'],
  state_2: ['name'],
  zipCode_2: ['alphaNumeric'],
  phone_2: ['phone'],
  username: ['ssgUsername'],
  password: [],
  username_recovery: [],
  email_recovery: ['email'],
  customPoints: ['points'],
  termsConditions: ['required'],
  travelProtection: [],
  recaptchaToken: [],
};

const blackListRegex = /CVV|cardNumber/gi;
// const = {
//   'American Express': 'AX',
//   'Visa': 'VS',
// };

// const validationRulesExample = {
//   guest1: {
//     isRequired: true,
//     nonDuplicate: [],
//     rules: ['name'],
//   },
// }

// console.log(validationRulesExample);

class PaymentProvider extends Component {
  constructor(props) {

    super(props);

    this.paymentOptionsRef = React.createRef();
    this.amountsRef = React.createRef();
    this.recaptchaRef = React.createRef();

    // this.refs = {
    //   paymentOptionsRef = React.createRef(),
    //   amountsRef = React.createRef(),
    //   recaptchaRef = React.createRef(),
    // };
  }

  state = state

  async componentDidMount() {

    this._setDefaultValues();
    this._setDefaultValuesValidation();
    this.setLoader(true);

    const summaryResponse = await DataService.readSummary();
    const { sandalsAccountActive = true } = await DataService.isAccountServicesActive();

    if(sandalsAccountActive) {
      const accountsResponse = await DataService.getPrimaryAccount();
      const accountPointsResponse = await DataService.getAccountPoints();

      if(accountsResponse.status === 200 && accountPointsResponse.status === 200) {
        const profilesData = accountsResponse.content;
        const responseData = profilesData.primary_member;
        const addressData = responseData.Address;
        const pointsData = accountPointsResponse.content;
        const formattedBirth = responseData.birth_date ? moment.utc(new Date(responseData.birth_date)).format('YYYY-MM-DD') : '';
        const accountDataRequired = {
          accountNumber: profilesData.account_number || '',
          title: responseData.title || '',
          gender: responseData.gender || '',
          firstName: responseData.first_name || '',
          lastName: responseData.last_name || '',
          dateOfBirth: formattedBirth || '',
          address1: addressData.address1 || '',
          address2: addressData.address2 || '',
          city: addressData.city || '',
          state: addressData.state || '',
          country: addressData.country_code || '',
          zipCode: addressData.zip_code || '',
          phoneNumber: responseData.mobile_phone_number || responseData.landline_phone_number || responseData.landline_phone_number2 || '',
          tier: profilesData.member_level || '',
          email: responseData.email || '',
          points: pointsData.points_available || 0,
        };

        const sandalsAccountResponse = await DataService.setSandalsAccountCookie(accountDataRequired);
        const accountProfileActive = profilesData.isActive;

        console.log('Process Sandals Accounts:', sandalsAccountResponse.code, profilesData);
        const sessionExpired = sessionExpiredCookie() === 'true';

        this.setState({
          canApplyPointsWithAccounts: accountProfileActive && !sessionExpired ? true : false,
          isLoggedAccounts: true,
          accountProfileInformation: profilesData
        });
      }
    }
    const ssgMemberInfo = {...summaryResponse.content.ssgMember};
    const ssgOffer = {...summaryResponse.content.ssgOffer};
    const { fields } = this.state;
    let { isLogged, isLogin, priceToPay } = this.state;

    let ssgPointsToUse = 0;

    if(Object.keys(ssgOffer).length > 0) {
      this.setState({ appliesPointsOffer: true });
    }

    if (summaryResponse.code === 1) {
      ssgPointsToUse = summaryResponse.content.ssgMember ? summaryResponse.content.ssgMember.pointsUsed : 0;
      const points = summaryResponse.content.ssgMember ? summaryResponse.content.ssgMember.points : 0;
      const maxApplyPoints = summaryResponse.content.roomData.maxApplyPoints || 0;
      const pointsOffer = summaryResponse.content.ssgOffer ? summaryResponse.content.ssgOffer.offer : 0;
      const ssgOfferApplied = summaryResponse.content.ssgOfferApplied ? summaryResponse.content.ssgOfferApplied : false;
      let ssgPointsType = 'none';

      if (ssgPointsToUse === maxApplyPoints || ssgPointsToUse === points) {
        ssgPointsType = 'all';
      } else if (ssgPointsToUse < (maxApplyPoints - pointsOffer) && ssgPointsToUse > 0) {
        ssgPointsType = 'custom';
      } else if (ssgPointsToUse === 0) {
        ssgPointsType = 'none';
      }

      // https://sanserviceshn.atlassian.net/browse/ORS-1990 Cart Abandonment shall happen as step5 loads here
      this.buildCM(summaryResponse);

      this.setState({
        summaryResponse: summaryResponse.content,
        summaryLoaded: true,
        appliedOffer: ssgOfferApplied,
        finalHoldOption: summaryResponse.content.holdOption,
        maxApplyPoints,
      }, () => {
        this.setInitialDiscount(ssgPointsToUse, ssgPointsType);
      });

    }

    // Get Gateways
    const gatewaysResponse = await DataService.readGateways();

    // Refactor after Willmer's change to dataservice method
    if (gatewaysResponse.code === 1) {
      const gateways = {};

      for(const item of gatewaysResponse.content) {
        gateways[item.gateway.toLowerCase()] = {
          city: item.city.toLowerCase(),
          airportName: item.airportName,
          gateway: item.gateway.toLowerCase(),
        };
      }

      this.setState({ gateways });
    }

    const countriesResponse = await DataService.getCountries();
    const travelInsuranceResponse = await DataService.readTravelInsurance();
    const layawayResponse = await DataService.readPaymentPlans();

    this.setLoader(false);

    if (countriesResponse.code === 1) {
      this.setState({ countries: countriesResponse.content });
    }

    let hasTravelProtectionPlan = 'false';

    if(travelInsuranceResponse.code === 1) {

      const travelInsuranceData = travelInsuranceResponse.content;
      const filterAdultsPriceData = travelInsuranceData.filter(data => data.guestType === 'A' && data.amount > 0);
      const filterChildrenPriceData = travelInsuranceData.filter(data => data.guestType === 'C' && data.amount > 0);
      const travelInsurancePricePerAdult = typeof filterAdultsPriceData[0] !== 'undefined' ? filterAdultsPriceData[0].amountPerGuest : 0;
      const travelInsurancePricePerChild = typeof filterChildrenPriceData[0] !== 'undefined' ? filterChildrenPriceData[0].amountPerGuest : 0;
      const hasFreeInsurancePromotion = travelInsuranceData.some((data) => data.amount === 0);
      const travelInsurancePrice = travelInsuranceData
        .reduce((accumulator, currentValue) => accumulator + currentValue.amount, 0);

      hasTravelProtectionPlan = hasFreeInsurancePromotion ? 'false' : 'true';
      !hasFreeInsurancePromotion && this.setState({ hasInsurance: 'false' }); // change only to 'true' when the default option of the TPP is 'Yes', and remember change the default value of travelProtection field.

      this.setState({
        travelInsurancePrice,
        travelInsurancePricePerAdult,
        travelInsurancePricePerChild,
        travelInsuranceData,
        hasFreeInsurancePromotion
      });
    }

    if(travelInsuranceResponse.code === 0) {
      this.setState({ travelInsurancePrice: -1 });
    }

    this.setLayawayResponse(layawayResponse);
    this._recalculatePrice(!hasTravelProtectionPlan, ssgPointsToUse);

    priceToPay = this.state.finalBookingPrice;
    fields.amount_1 = priceToPay;

    this.setState({ priceToPay, fields });

    // weird validation (== 0) because backend send this value when the user logut.// changes may be requiered here.
    if (ssgMemberInfo && ssgMemberInfo.ssgNumber !== 0 && ssgMemberInfo.ssgNumber !== undefined) {
      isLogged = true;
      isLogin = false;
      this.setGuestAddress('true', 'guestAddress_1', 'ssg');
      this.setState({ ssgMemberInfo, isLogged, isLogin });
    } else {
      this.setGuestAddress('true', 'guestAddress_1');
    }
  }

  setAccountsPassword = (value) => {

    this.setState({ accountPassword: value });
  }

  loadAccounts = async() => {
    const password = this.state.accountPassword;

    const accountsResponse = await DataService.getAccountsSessionValidation(password);

    this.setState({accountLoading: true});

    if(accountsResponse.status === 200) {
      createSessionExpiredCookie(0);
      this.setState({ canApplyPointsWithAccounts: true, invalidAccounstPassword: false, accountLoading: false });
    }else {
      this.setState({invalidAccounstPassword: true, accountLoading: false});
    }
  }

  buildCM = (summaryResponse) => {
    const { code: summaryCode, content: summaryContent = {} } = summaryResponse;

    if (summaryCode === 1) {
      const { roomData, flightsData } = summaryContent;
      const { rstCode, roomCode } = roomData;

      if (!flightsData) {
        cm.cmCreateShopAction5Tag(rstCode, roomCode, summaryContent);
      }

    }
  }

  setLoader = (value) => {
    this.setState({ layawayLoading: value });
  }

  setAppliedOffer = (value) => {
    this.setState({ appliedOffer: value});
  }
  setAppliedPoints = (value) => {
    this.setState({ appliedPoinst: value});
  }

  setLayawayResponse = (layawayResponse) => {
    if (layawayResponse.code === 1) {
      this.setState({ layawayResponse: layawayResponse.content });

      this.setInputValue('', 'layawayPlanOption');
      // this.setInputValue('', 'acceptLayaway');

      this._prepareLayawayOptions(layawayResponse.content);
    }
  }

  _setDefaultValuesValidation = () => {
    const fieldsRules = validationRules;
    const namedFields = Object.keys(fieldsRules);
    let fieldValidations = { ... this.state.fieldValidations };

    fieldValidations = {};

    namedFields.map((field) => {
      fieldValidations[field] = true;
    });

    this.setState({fieldValidations});
  }

  _setDefaultValues = () => {
    const fieldsRules = validationRules;
    const namedFields = Object.keys(fieldsRules);
    let fields = {...this.state.fields};

    fields = {};

    namedFields.map(field => {
      fields[field] = '';
      if (field === 'paymentOption') {
        fields[field] = 'fullVacation';
      }
      // this field is not used
      if (field === 'travelProtection') {
        fields[field] = '';
      }
    });

    this.setState({ fields });
  }

  setGuestAddress = (value, inputName, type = 'custom') => {
    const guestsData = {...this.state.summaryResponse.guestsData};
    const ssgData = {...this.state.summaryResponse.ssgMember};
    const fieldValidations = {...this.state.fieldValidations};
    const fields = {...this.state.fields};
    const suffix = inputName.split('_')[1];
    const guestMap = {
      [`streetAddress_${suffix}`]: 'address1',
      [`streetAddress2_${suffix}`]: 'address2',
      [`country_${suffix}`]: 'country',
      [`state_${suffix}`]: 'state',
      [`city_${suffix}`]: 'city',
      [`zipCode_${suffix}`]: 'zipCode',
    };

    const guestSSGMap = {
      'streetAddress_1': 'address1',
      'country_1': 'country',
      'state_1': 'state',
      'city_1': 'city',
      'zipCode_1': 'zipcode',
      'phone_1': 'phoneNumber'
    };

    const additionalProperties = {
      [`isInputDisabled_${suffix}`]: null,
    };

    // In guests page, user can send state or province but in payment is the same parameter
    if (guestsData.state === '' || guestsData.country === 'CA') {
      guestMap[`state_${suffix}`] = 'province';
    }

    // prepopulated one phone number
    if (guestsData.phoneNumber !== '') {
      guestMap[`phone_${suffix}`] = 'phoneNumber';
    }

    let fieldNames = null;
    let fieldsMap = null;
    let data = null;

    if (type === 'ssg') {
      fieldNames = Object.keys(guestSSGMap);
      fieldsMap = guestSSGMap;
      data = ssgData;
    } else {
      fieldNames = Object.keys(guestMap);
      fieldsMap = guestMap;
      data = guestsData;
    }

    fieldNames.map(name => {
      if (value === 'true') {
        fields[name] = data[fieldsMap[name]] || '';
        fieldValidations[name] = true;

        // avoid disabling inputs in first page load and user is SSG
        if (type === 'custom') {
          additionalProperties[`isInputDisabled_${suffix}`] = true;
        }
      } else {
        fields[name] = '';
        additionalProperties[`isInputDisabled_${suffix}`] = false;
      }
    });

    this.zipCodeValidation(`country_${suffix}`, fields[`country_${suffix}`]);
    this.setState({
      fields,
      fieldValidations,
      [inputName]: type === 'ssg' ? 'false' : value,
      [`isInputDisabled_${suffix}`]: additionalProperties[`isInputDisabled_${suffix}`]
    });

    return fields[`country_${suffix}`];
  }

  _updateFields = (newFields, cb = () => {}) => {

    const { ...oldFields } = this.state.fields;
    const fields = { ...oldFields, ...newFields };
    let { warning } = this.state;

    warning = false;

    this.setState({ fields, warning }, cb);
  }

  _updateFieldValidations = (newFields) => {

    const { ...oldFields } = this.state.fieldValidations;
    const fieldValidations = { ...oldFields, ...newFields };

    this.setState({ fieldValidations });
  }

  _getCardType = (cc) => validator.ccNumber.getCardType(cc).card.type;

  _setCardType = (value, name, isCardNumber, fieldValidation) => {

    let cardTypeId = '';

    if(name === 'cardNumber_1') {
      cardTypeId = 'cardType_1';
    }

    if(name === 'cardNumber_2') {
      cardTypeId = 'cardType_2';
    }

    if(isCardNumber) {

      const ccValid = fieldValidation.validationsObject[name].ccNumber;
      const validCreditCard = ccValid && ccValid.isValid;
      const cardType = (isCardNumber && validCreditCard) ? this._getCardType(value) : '';

      this._updateFields({[name]: value, [cardTypeId]: cardType});
    }
  }

  // prepare layaway options
  _prepareLayawayOptions = (json) => {

    const paymentTerms = ([...new Set(json.map((item) => item.paymentTerm))]).sort((a, b) => a - b);

    this.setState({ paymentTerms });
  }

  // populate layway details
  _populateLayawayPayment = (value) => {
    const { layawayResponse } = this.state;
    const term = Number(value);

    const filteredLayawayData = layawayResponse.filter((item) => (item.paymentTerm === term));

    this.setState({ filteredLayawayData });
  }

  toggleRequired = (fieldNameArray = []) => {
    const required = 'required';

    return () => {
      fieldNameArray.map(fieldName => {
        const [...validationArray] = validationRules[fieldName];
        const indexOfRequired = validationArray.indexOf(required);

        if (indexOfRequired > -1) {
          validationArray.splice(indexOfRequired, 1);
        } else {
          validationArray.push(required);
        }

        validationRules[fieldName] = validationArray;
      });
    };
  }

  removeRequired = (fieldNameArray = []) => {
    const required = 'required';

    return () => {
      fieldNameArray.map(fieldName => {
        const [...validationArray] = validationRules[fieldName];
        const indexOfRequired = validationArray.indexOf(required);

        if (indexOfRequired > -1) {
          validationArray.splice(indexOfRequired, 1);
        }

        validationRules[fieldName] = validationArray;
      });
    };
  }

  toggleccNumber = (fieldNameArray = []) => {
    const ccNumber = 'ccNumber';

    return () => {
      fieldNameArray.map(fieldName => {
        const [...validationArray] = validationRules[fieldName];
        const indexOfccNumber = validationArray.indexOf(ccNumber);

        if (indexOfccNumber > -1) {
          validationArray.splice(indexOfccNumber, 1);
        } else {
          validationArray.push(ccNumber);
        }

        validationRules[fieldName] = validationArray;
      });
    };
  }

  zipCodeValidation = (name, value) => {
    const { fieldValidations } = this.state;
    const countrySuffix = name.split('_')[1];
    const zipCode = `zipCode_${countrySuffix}`;
    const zipCodeValue = this.state.fields[zipCode];
    const countryValue = value.toLowerCase();

    // credit card information zipcode always required for US, CA or GB.
    switch(countryValue) {
      case 'us':
        validationRules[zipCode] = ['required', 'zipCodeUS'];
        break;
      case 'ca':
        validationRules[zipCode] = ['required', 'zipCodeCA'];
        break;
      case 'gb':
        validationRules[zipCode] = ['required', 'alphaNumeric'];
        break;
      default:
        validationRules[zipCode] = ['alphaNumeric'];
    }

    const fieldValidation = validationEngine.runValidations(validationRules, zipCodeValue, zipCode);

    fieldValidations[zipCode] = fieldValidation.allValid;

    this._updateFieldValidations({ [zipCode]: fieldValidation.allValid });
  }

  setInputValue = (value, name, e, cb = () => {}) => {
    const inputValue = value.trim();
    const fieldValidation = validationEngine.runValidations(validationRules, inputValue, name);
    const { paymentOption } = this.state.fields;

    this._updateFieldValidations({[name]: fieldValidation.allValid});

    name === 'layawayPlanOption' && this._populateLayawayPayment(inputValue);
    if (name.includes('cardNumber')) { this.setState({ repeatedCard: false }); }
    if (name.includes('amount')) { this.checkMinAmount(name, value); }
    if (paymentOption === 'otherAmount') {
      if (name.includes('amount')) {
        this.setPriceToPay(name, inputValue, true);
      }
    }

    // not the cleanest way, but understandable.
    // this will check if the value being updated is from a cc field and run a function that will set
    // the credit card type

    const isCardNumber = ((name === 'cardNumber_1') || (name === 'cardNumber_2'));

    !isCardNumber ? this._updateFields({[name]: inputValue}, cb) : this._setCardType(inputValue, name, isCardNumber, fieldValidation);

    if (name === 'numberOfCards') { this.setCardsValidations(name, inputValue); }
    if (name === 'paymentOption') { this.checkPaymentOption(inputValue); }
    if (name === 'amount_1') { this.resetAmountInput(name, inputValue); }
  }

  setSSGPointsType = (value) => {
    this.setState({ ssgPointsType: value });
  }

  setCCIdValue = (value) => {
    this.setState({ ccId: value });
  }

  setAcceptedTerms = (value) => {
    const fields = {...this.state.fields};
    const fieldValidations = {...this.state.fieldValidations};

    if (value)  {
      fields.termsConditions = 'true';
      fieldValidations.termsConditions = true;
      this.closeModal('terms')();
    } else {
      fields.termsConditions = '';
      fieldValidations.termsConditions = false;
    }

    this.setState({ fields, fieldValidations });
  }

  // Weird business rule
  resetAmountInput = (name, value) => {
    const { totalCards, fields } = this.state;
    const { paymentOption } = this.state.fields;

    if (totalCards === 'twoCards') {
      fields.amount_1 = value;
      fields.amount_2 = '';
    }

    if(paymentOption === 'otherAmount') {
      if (totalCards !== 'twoCards') {
        fields.amount_1 = value;
      }
    }

    this.setState({ fields });
  }

  resetState = (name, value) => {
    const { fields } = this.state;
    const countrySuffix = name.split('_')[1];
    const stateField = `state_${countrySuffix}`;
    const { fieldValidations } = this.state;

    fields[stateField] = '';

    validationRules[stateField] = ['required', 'name'];

    const stateValidation = validationEngine.runValidations(validationRules, value, stateField);

    fieldValidations[stateField] = stateValidation.allValid;

    this.setState({ fields, fieldValidations });
  }

  checkMinAmount = (name, value) => {
    const { finalBookingPrice, finalHoldOption, minAmountPerCard } = this.state;
    const depositTotalAmount = this.state.summaryResponse.roomData.depositTotalAmount || 0;
    const fieldValidation = {};
    const { paymentOption } = this.state.fields;

    let { validTotalAmount } = this.state;
    let minValue = null;

    if (paymentOption === 'otherAmount') {
      if(name === 'amount_1') {
        minValue = parseFloat(finalHoldOption, 10);
      }
      if(name === 'amount_2') {
        minValue = minAmountPerCard;
      }
    } else {
      minValue = (depositTotalAmount > 400 && name === 'amount_1') ? depositTotalAmount : minAmountPerCard;
    }

    if (parseFloat(value, 10) < minValue || (parseFloat(value, 10) > finalBookingPrice)) {
      fieldValidation.allValid = false;

      this._updateFieldValidations({[name]: fieldValidation.allValid});

      return false;
    }

    validTotalAmount = true;

    this.setState({ validTotalAmount });

    return true;
  }

  checkFinalAmount = () => {
    const fields = {...this.state.fields};
    const { priceToPay, totalCards } = this.state;

    if (fields.amount_2 === '' && totalCards === 'oneCard') {
      fields.amount_2 = 0;
    }

    if (console.table) {
      console.table({
        'hold option': this.state.summaryResponse.holdOption,
        'travel insurance': this.state.travelInsurancePrice,
        'flights': this.state.summaryResponse.flightsData ? this.state.summaryResponse.flightsData.priceInfo.grandTotalAmount : 0,
        'room price': this.state.summaryResponse.roomData.afterPromoRate,
        'Total Vacation Price': this.state.finalBookingPrice,
        'PRICE TO PAY': priceToPay,
      });
    } else {
      console.log('hold option ⌚️', this.state.summaryResponse.holdOption);
      console.log('travel insurance 🛡', this.state.travelInsurancePrice);
      console.log('flights ✈️', this.state.summaryResponse.flightsData ? this.state.summaryResponse.flightsData.priceInfo.grandTotalAmount : 0);
      console.log('room price ⚰️', this.state.summaryResponse.roomData.afterPromoRate);
      console.log('Total Vacation Price 🏢', this.state.finalBookingPrice);
      console.log('PRICE TO PAY 💰', priceToPay);
    }

    const totalAmount = (parseFloat(fields.amount_1, 10) + parseFloat(fields.amount_2, 10)).toFixed(2);

    if (parseFloat(totalAmount, 10) !== parseFloat(priceToPay, 10)) {

      return false;
    }

    return true;
  }

  checkCardsValue = () => {
    /* eslint-disable camelcase*/
    const fields = {...this.state.fields};
    const { totalCards } = this.state;
    const { cardNumber_1 = '', cardNumber_2 = '' } = fields;

    if (cardNumber_1.length > 0 && totalCards === 'twoCards') {

      if (cardNumber_1 === cardNumber_2) {

        return true;
      }
    }

    return false;
    /* eslint-enable camelcase*/
  }

  setPriceToPay = (name, value, forOtherAmount = false) => {
    const { finalBookingPrice, finalHoldOption, totalCards } = this.state;
    const fields = this.state.fields;
    let { priceToPay } = this.state;
    let currentValue = parseFloat(value, 10);

    if(totalCards === 'twoCards') {
      if(name === 'amount_1') {
        currentValue = parseFloat(fields.amount_2, 10) + parseFloat(value, 10);
      }
      if(name === 'amount_2') {
        currentValue = parseFloat(fields.amount_1, 10) + parseFloat(value, 10);
      }
    }

    if (currentValue >= finalHoldOption && currentValue <= finalBookingPrice) {
      priceToPay = currentValue;
    } else {
      priceToPay = parseFloat(finalBookingPrice, 10); // parseFloat(finalHoldOption, 10);
    }

    this.setState({ priceToPay }, () => {
      this.checkPaymentOption('otherAmount', forOtherAmount);
    });
  }

  /* For you dear dev who gives maintance to this mess

    https://sanserviceshn.atlassian.net/browse/ORS-1311

    May the force be with you 🤖
    - Im really sorry, please don't hate me.
  */
  checkPaymentOption = (value, forOtherAmount = false) => { // maybe add the uplift verification here
    const { finalHoldOption, finalBookingPrice, fieldValidations, fields, minAmountPerCard } = this.state;
    const namedFields = Object.keys(fields);
    const { summaryResponse, hasInsurance } = this.state;
    const hasFlights = (summaryResponse.flightsData);
    const flightPrice = hasFlights ? this.state.summaryResponse.flightsData.priceInfo.grandTotalAmount : 0;
    const depositTotalAmount = this.state.summaryResponse.roomData.depositTotalAmount;
    const depositAmount = this.state.summaryResponse.roomData.depositAmount;

    const insuranceAmount = this.state.travelInsurancePrice;
    const roomsFlightsAmount = depositAmount + flightPrice;
    const roomsInsuranceAmount = depositAmount + insuranceAmount;
    const tppOptionSelected = this.state.tppOptionSelected;
    const hasFreeInsurancePromotion = this.state.hasFreeInsurancePromotion;
    const travelInsurancePrice = this.state.travelInsurancePrice;

    let { totalCards, priceToPay, disabled, ccId, enabledAmountField, upliftWasSelected } = this.state;
    let paymentMethod = 'other';

    switch(value) {
      case 'holdOption':
        paymentMethod = 'hold';
        break;

      case 'fullVacation':
        paymentMethod = 'full';
        break;

      case 'otherAmount':
        paymentMethod = 'deposit';
        break;

      default:
        paymentMethod = 'other';
        break;
    }

    if(fields.paymentOption === 'uplift' && value !== 'uplift') {
      if(window.Uplift) {
        window.Uplift.Payments.deselect(paymentMethod);
      }
      upliftWasSelected = false;
    }

    fields.paymentOption = value;
    priceToPay = (parseFloat(priceToPay)).toFixed(2) || priceToPay;

    if (value === 'holdOption') {

      priceToPay = finalHoldOption;

      // if user doesnt have air and insurance only one card to payment
      if (hasFlights === undefined && hasInsurance === 'false') {
        totalCards = 'oneCard';
        fields.amount_2 = '';
        this.cleanCreditCardCredentials(namedFields, fieldValidations);
      }

    } else if (value === 'otherAmount') {
      fields.otherAmount = finalBookingPrice;
      fieldValidations.otherAmount = true;

      // price to pay already setted in setPriceToPay method when the user type on the input, but in recalculations need to be trigger here
      validationRules.otherAmount = ['amount', 'required'];
      disabled = false;

      /* Checking correct amount in other amount field onChange event */
      // if (hasTravelPlan && fields.otherAmount < finalHoldOption) {
      //   fields.otherAmount = parseFloat(finalHoldOption, 10);
      //   priceToPay = parseFloat(finalHoldOption, 10);
      // } else if (fields.otherAmount > finalHoldOption && fields.otherAmount <= finalBookingPrice) {
      //   priceToPay = fields.otherAmount;
      // } else if (fields.otherAmount > finalBookingPrice) {
      //   priceToPay = finalBookingPrice;
      //   fields.otherAmount = finalBookingPrice;
      // }

      // if (priceToPay === fields.otherAmount) {
      //   fieldValidations.otherAmount = true;
      // }

      // if user doesnt have air or insurance
      if (fields.otherAmount === '' || (fields.otherAmount <= roomsFlightsAmount && fields.otherAmount <= roomsInsuranceAmount)) {
        totalCards = 'oneCard';
        fields.amount_2 = '';
        this.cleanCreditCardCredentials(namedFields, fieldValidations);
      }

      if (hasFlights === undefined && hasInsurance === 'false' && (fields.otherAmount <= roomsFlightsAmount && fields.otherAmount <= roomsInsuranceAmount)) {
        totalCards = 'oneCard';
        fields.amount_2 = '';
        this.cleanCreditCardCredentials(namedFields, fieldValidations);
      }

    } else if (value === 'fullVacation') {

      priceToPay = finalBookingPrice;

    } else if (value === 'layaway') {

      // setting required fields
      // validationRules.acceptLayaway = ['required'];
      validationRules.layawayPlanOption = ['alphaNumeric', 'required'];

      // setting price to pay which is the first payment option
      /* finalHoldOption contains the amount of the first payment in layaway plan */
      priceToPay = finalHoldOption;
      totalCards = 'oneCard';
      fields.amount_2 = '';
      this.cleanCreditCardCredentials(namedFields, fieldValidations);
    } else if (value === 'uplift') {
      // Travel Protection Plan Validator 
      if(!tppOptionSelected && !hasFreeInsurancePromotion && travelInsurancePrice > 0) {
        const tppRequiredWarning = true;

        this.setState({tppRequiredWarning});
        this._onErrorScroll('ttpSection');
      }

      if(!upliftWasSelected) {
        window.Uplift.Payments.select();
      }
      upliftWasSelected = true;
      priceToPay = finalBookingPrice;
    }

    // cleaning values when user selects another option, cleaning fields. // use this for the execution or remove it
    if (value !== 'otherAmount') {
      fields.otherAmount = '';
      validationRules.otherAmount = ['amount'];
      fieldValidations.otherAmount = true;
      fieldValidations.amount_1 = true;
      disabled = true;
    }

    // cleaning validations and errors when user desselect layaway plan
    if (value !== 'layaway') {
      fields.layawayPlanOption = '';
      // fields.acceptLayaway = '';
      // validationRules.acceptLayaway = [];
      validationRules.layawayPlanOption = ['alphaNumeric'];
      // fieldValidations.acceptLayaway = true;
      fieldValidations.layawayPlanOption = true;
    }

    // one credit card amount input is hidden

    if(value !== 'otherAmount') {
      if (totalCards === 'oneCard') {
        fields.amount_1 = priceToPay;
        fields.cardType_2 = '';
        fields.cardNumber_2 = '';
        ccId = '1';

        if(value === 'fullVacation' || value === 'holdOption' || value === 'layaway') {
          enabledAmountField = true;
        }else {
          enabledAmountField = false;
        }
      } else {
        // removed error messages
        fieldValidations.amount_1 = true;
        fieldValidations.amount_2 = true;

        // default values for each amount
        if (depositTotalAmount > 400) {
          fields.amount_1 = (depositTotalAmount).toFixed(2);
          fields.amount_2 = (priceToPay - depositTotalAmount).toFixed(2);

          enabledAmountField = false;

        } else {
          enabledAmountField = false;
          fields.amount_1 = minAmountPerCard.toFixed(2);
          fields.amount_2 = (priceToPay - minAmountPerCard).toFixed(2);
        }
      }
    }


    // custom rule validate other amout vs amount 1
    if (value === 'otherAmount') {
      enabledAmountField = false;
      if (totalCards === 'oneCard') {
        if(!forOtherAmount) {
          fields.amount_1 = '';
        }
      }else if (totalCards === 'twoCards') {
        if(!forOtherAmount) {
          fields.amount_1 = '';
          fields.amount_2 = '';
        }
      }
    }

    this.setState({
      totalCards,
      priceToPay,
      fieldValidations,
      fields,
      enabledAmountField,
      disabled,
      ccId,
      upliftWasSelected,
    });
  }

  cleanCreditCardCredentials = (namedFields, fieldValidations) => {
    validationRules.cardNumber_2 = [];

    this.removeRequired([
      'amount_2',
      'cardHolder_2',
      'cardNumber_2',
      'expirationMonth_2',
      'expirationYear_2',
      'CVV_2',
      'streetAddress_2',
      'city_2',
      'country_2',
      'state_2',
      'zipCode_2',
      'phone_2'
    ])();

    namedFields.map(field => {
      if (field.includes('_2')) {
        fieldValidations[field] = true;
      }
    });
  }

  setCardsValidations = (name, value) => {
    const fields = {...this.state.fields};
    const namedFields = Object.keys(fields);
    const fieldValidations = { ... this.state.fieldValidations };
    let { totalCards, repeatedCard, ccId, validTotalAmount } = this.state;

    // reset errors if user removes the second card.
    if (value === 'oneCard') {

      for (const field of namedFields) {
        if (field.includes('_2')) {
          const required = 'required';
          const indexOfRequired = validationRules[field].indexOf(required);

          fieldValidations[field] = true;
          fields[field] = '';

          if (indexOfRequired > -1) {
            validationRules[field].splice(indexOfRequired, 1);
          }
        }
      }
      // one card default ccId
      ccId = '1';
    } else {
      this.toggleRequired([
        'amount_2',
        'cardHolder_2',
        'cardNumber_2',
        'expirationMonth_2',
        'expirationYear_2',
        'CVV_2',
        'streetAddress_2',
        'city_2',
        'country_2',
        'phone_2'
      ])();
    }

    // removed error messages
    fieldValidations.amount_1 = true;
    fieldValidations.amount_2 = true;
    validTotalAmount = true;

    repeatedCard = false;
    totalCards = value;

    this.toggleccNumber(['cardNumber_2'])();

    this.setState({ fields, fieldValidations, totalCards, repeatedCard, ccId, validTotalAmount }, () => {
      // rechecking the price to pay if user modify amount 1 input
      this.checkPaymentOption(fields.paymentOption);
    });
  }

  setTravelProtectionPlan = (value, name) => { // changes here

    const hasTravelProtectionPlan = value === '' ? 'false' : value;
    const tppOptionSelected = true;
    const tppRequiredWarning = false;

    this.setInputValue(hasTravelProtectionPlan, name);

    // recalculate total price
    const { ssgPointsToUse: points = 0 } = this.state;

    this.setState({ hasInsurance: hasTravelProtectionPlan, tppOptionSelected, tppRequiredWarning });
    this._recalculatePrice(hasTravelProtectionPlan, points);
  }

  setPoints = (points = 0, type = 'none') => {
    const fieldValidations = { ... this.state.fieldValidations };

    fieldValidations.customPoints = true;

    this.closeModal('applyPoints')();
    this.setState({ ssgPointsToUse: points, ssgPointsType: type, fieldValidations });

    // recalculate total price
    const { hasInsurance = false } = this.state;

    this._recalculatePrice(hasInsurance, points);
  }

  setInitialDiscount = (points = 0, type = 'none') => {
    this.setState({ ssgPointsToUse: points, ssgPointsType: type });

    // recalculate total price
    const { hasInsurance = false } = this.state;

    this._recalculatePrice(hasInsurance, points);
  }

  _recalculatePrice = (hasTravelProtectionPlan, points) => {
    const { paymentOption } = this.state.fields;
    const { summaryResponse } = this.state;

    const ssgPointsToUse = this._calculatePoints(points);
    const { travelInsurancePrice, appliesPointsOffer, appliedOffer } = this.state;

    const hasFlights = (summaryResponse.flightsData);
    let pointsOffer = 0;

    pointsOffer = appliedOffer && appliesPointsOffer ? summaryResponse.ssgOffer.offerAmount : 0;

    // flight price
    const flightPrice = hasFlights ? summaryResponse.flightsData.priceInfo.grandTotalAmount : 0;
    // final booking price //use this to calculate the uplift price
    let finalBookingPrice = summaryResponse.roomData.afterPromoRate + flightPrice - ssgPointsToUse - pointsOffer; // remove this shit

    if(hasTravelProtectionPlan === 'true' && travelInsurancePrice > -1) {
      finalBookingPrice = finalBookingPrice + travelInsurancePrice;
    }

    finalBookingPrice = roundNumber(finalBookingPrice);

    this.setState({ finalBookingPrice }, () => {
      if (paymentOption === 'fullVacation') {
        this.checkPaymentOption('fullVacation');
      }
    });

    this._recalculateHoldOption(hasTravelProtectionPlan, travelInsurancePrice, flightPrice);
  }

  _recalculateHoldOption = (hasTravelProtectionPlan, travelInsurancePrice) => {
    const fieldsCopy = { ... this.state.fields };
    const { paymentOption } = fieldsCopy;
    const finalHoldOptionCopy = this.state.finalHoldOption;

    // flight price ------------------ CONSTANT
    // travelProtectionPlan price ---- DYNAMIC
    // has travelProtectionPlan? ----- DYNAMIC

    let finalHoldOption = this.state.summaryResponse.holdOption;

    if(travelInsurancePrice > -1) {
      finalHoldOption = hasTravelProtectionPlan === 'true'
        ? (finalHoldOption + travelInsurancePrice)
        : finalHoldOption;
    }

    if (hasTravelProtectionPlan === 'false') {
      fieldsCopy.otherAmount = finalHoldOption;
    }

    finalHoldOption = parseFloat(finalHoldOption.toFixed(2)) || finalHoldOption;

    if(finalHoldOption !== finalHoldOptionCopy && paymentOption === 'otherAmount') {
      fieldsCopy.amount_1 = '';
    }

    this.setState({ finalHoldOption, fields: fieldsCopy }, () => {
      if (paymentOption === 'otherAmount') {
        this.checkPaymentOption('otherAmount', true);
      } else {
        this.checkPaymentOption(paymentOption);
      }
    });
  }

  _calculatePoints = (points = '') => Math.round((points * 0.025) * 100) / 100;

  // SSG Login methods
  _updateCredentials = (newCredentials) => {

    const { ...oldCredentials } = this.state.ssgCredentials;
    const ssgCredentials = { ...oldCredentials, ...newCredentials };

    this.setState({ ssgCredentials });
  }

  setSSGState = (name = '', value = '') => {
    const ssgCredentials = { ...this.state.ssgCredentials };
    const ssgResponse = { ...this.state.ssgResponse };
    const fieldValidation = validationEngine.runValidations(validationRules, value, name);

    ssgResponse.message = '';
    ssgResponse.code = -1;
    ssgCredentials[name] = value;

    this._updateFieldValidations({[name]: fieldValidation.allValid});
    this._updateCredentials(ssgCredentials);
    this.setState({ ssgResponse });
  }

  setRecoveryValue = (value, name) => {
    const fieldValidation = validationEngine.runValidations(validationRules, value, name);
    const recoverySSGCredentials = {...this.state.recoverySSGCredentials};
    const recoverySSGResponse = {...this.state.recoverySSGResponse};

    recoverySSGCredentials[name] = value;
    recoverySSGResponse.code = -1;

    this._updateFieldValidations({[name]: fieldValidation.allValid});
    this.setState({ recoverySSGCredentials, recoverySSGResponse });
  }

  // setPoints = (points) => {

  //   this.closeModal('applyPoints')();
  //   this.setState({ ssgPointsToUse: points });

  //   // recalculate total price
  //   const { travelProtection: hasTravelProtectionPlan = false } = this.state.fields;

  //   this.recalculatePrice(hasTravelProtectionPlan, points);
  // }

  // Validations methods
  getFields = () => { return {...this.state.fields}; }

  toggleSSGModal = (name) => {
    return () => {
      let { isForgotPassword, isLogin, isPassword } = this.state;
      const {...fieldValidations} = this.state.fieldValidations;
      const {...ssgCredentials} = this.state.ssgCredentials;

      isForgotPassword = !isForgotPassword;

      // reseting previous content
      if (isForgotPassword) {
        ssgCredentials.username = '';
        ssgCredentials.password = '';
        isLogin = false;
        fieldValidations.username = true;
        fieldValidations.password = true;
      }

      // validation used for change modal content
      if (name === 'username') {
        isPassword = false;
      } else {
        isPassword = true;
      }

      this.toggleRequired(['username_recovery', 'email_recovery'])();

      this.setState({
        isForgotPassword,
        isLogin,
        isPassword,
        ssgCredentials,
        fieldValidations
      });
    };
  }

  _resetSSGForm = ([...fields]) => {
    const fieldValidations = { ...this.state.fieldValidations };
    const recoverySSGCredentials = {...this.state.recoverySSGCredentials};
    const recoverySSGResponse = {...this.state.recoverySSGResponse};
    const ssgCredentials = {...this.state.ssgCredentials};
    const ssgResponse = {...this.state.ssgResponse};

    ssgCredentials.username = '';
    ssgCredentials.password = '';
    ssgCredentials.recaptchaToken = '';

    recoverySSGCredentials.username_recovery = '';
    recoverySSGCredentials.email_recovery = '';

    fields.map(field => {
      fieldValidations[field] = true;
    });

    // loggin field
    fieldValidations.customPoints = true;

    // reseting responses
    ssgResponse.code = -1;
    recoverySSGResponse.code = -1;

    this.setState({
      fieldValidations,
      ssgCredentials,
      recoverySSGCredentials,
      recoverySSGResponse,
      ssgResponse
    });
  }

  // Modal funcionality methods
  openModal = (name, e = null) => {
    const { showRecaptcha } = this.state;
    const currentState = {...this.state.isModalOpen};

    e && e.preventDefault();
    currentState[name] = true;

    if (showRecaptcha) {
      this.toggleRequired(['username', 'password', 'recaptchaToken'])();
    } else {
      this.toggleRequired(['username', 'password'])();
    }

    this.setState({ isModalOpen: currentState});
  }

  closeModal = (name) => {
    const { isLogged, showRecaptcha } = this.state;
    let { isForgotPassword, isLogin } = this.state;

    return () => {
      const currentState = {...this.state.isModalOpen};

      currentState[name] = false;

      /* you all this sandunga because business says that recaptcha must appear after 5 attemps
        ***please be careful
      */
      if (isForgotPassword) {
        if (showRecaptcha) {
          this.toggleRequired(['username_recovery', 'username', 'password', 'email_recovery', 'recaptchaToken'])();
        } else {
          this.toggleRequired(['username_recovery', 'username', 'password', 'email_recovery'])();
        }
      } else {
        if (showRecaptcha) {
          this.toggleRequired(['username', 'password', 'recaptchaToken'])();
        } else {
          this.toggleRequired(['username', 'password'])();
        }
      }

      if (!isLogged) {
        isForgotPassword = false;
        isLogin = true;
      }

      // reseting all values related to the ssg modal
      this._resetSSGForm(['username_recovery', 'username', 'password', 'email_recovery', 'recaptchaToken']);
      this.setState({ isModalOpen: currentState,
        isForgotPassword,
        isLogin,
      });
    };
  }

  // Data fetching methods
  trySubmit = (inputNames, fields, type = 'custom') => {
    const fieldValidations = { ... this.state.fieldValidations };
    const tppOptionSelected = this.state.tppOptionSelected;
    const hasFreeInsurancePromotion = this.state.hasFreeInsurancePromotion;
    const travelInsurancePrice = this.state.travelInsurancePrice;

    let { warning } = this.state;
    let noErrors = 0;

    // Re run validations to be sure that everything is ok.
    const invalidFields = inputNames.map((inputName) => {

      const inputValue = fields[inputName];

      const fieldValidation = validationEngine.runValidations(validationRules, inputValue, inputName);

      const ruleOptions = fieldValidation.validationsObject[inputName] || {};

      const getErrors = rules => Object.keys(rules).reduce(
        (result, ruleName) => (
          ruleOptions[ruleName].message || ''
        ), ''
      );

      this._updateFieldValidations({[inputName]: fieldValidation.allValid});

      // Travel Protection Plan Validator 
      if(type === 'custom') { // avoiding the scroll error when the TPP shows up
        if(!tppOptionSelected && !hasFreeInsurancePromotion && travelInsurancePrice > 0) {
          const tppRequiredWarning = true;

          noErrors++;
          this.setState({tppRequiredWarning});
          this._onErrorScroll('ttpSection');
        }
      }

      // Setting up styles in invalid fields and error counting.
      if (fieldValidation.allValid === false) {

        // avoiding scroll when the user interact with the ssg login
        if (noErrors === 0 && type === 'custom' && !inputName.includes('customPoints')) {
          warning = true;
          this._onErrorScroll(inputName);
        }
        noErrors++;
        fieldValidations[inputName] = false;

        // Banned Sensitive Information
        if (blackListRegex.test(inputName)) {
          return {
            [inputName]: {
              value: 'Hidden For Security Purposes.',
              error: getErrors(ruleOptions),
            }
          };
        }

        return {
          [inputName]: {
            value: fields[inputName],
            error: getErrors(ruleOptions),
          }
        };
      }

      // check each amount
      if (inputName.includes('amount') || inputName.includes('otherAmount')) {
        const validAmount = this.checkMinAmount(inputName, fields[inputName]);

        if (!validAmount) {
          noErrors++;
          warning = true;
          this._onErrorScroll(inputName);
        }
      }

      return {};
    }).reduce((result, errorField) => (
      Object.assign(result, errorField)
    ), {});

    // check if credit cards are the same
    const repeatedCard = this.checkCardsValue();

    if (repeatedCard && type === 'custom') {
      noErrors++;
      this._onErrorScroll('amount');

      invalidFields.repeatedCard = {
        value: 'Hidden For Security Purposes.',
        error: 'Repeated Card Number',
      };
    }

    // final check for the total amount
    const validTotalAmount = this.checkFinalAmount();

    if (!validTotalAmount && type === 'custom') {
      noErrors++;
      this._onErrorScroll();

      invalidFields.validTotalAmount = {
        value: !validTotalAmount,
        error: 'Total Amount Mismatched.',
      };
    }

    // Seding the user's errors to Splunk
    if (Object.keys(invalidFields).length > 0) {
      DataService.logFE({
        payload: JSON.stringify(invalidFields),
        uri: window.location.pathname,
        step: window._app.page.step,
      });

      const isnum = /^\d+$/.test(fields.CVV_1);

      DataService.logFE({
        payload: `CVV length is ${fields.CVV_1 ? fields.CVV_1.length : '0'} and is only numbers: ${isnum}`,
        uri: window.location.pathname,
        step: window._app.page.step,
      });
    }

    this.setState({ fieldValidations, warning, validTotalAmount, repeatedCard });

    return noErrors;
  }

  toggleLoader = (value) => {
    this.setState({ showLoader: value });
  }

  _onErrorScroll = (name = 'amount') => {
    let element = null;

    if (name.toLowerCase().includes('amount')) {
      element = document.getElementsByClassName('payment-options')[0];
    } else if(name.length > 0) {
      const inputs = document.getElementsByName(name);

      element = inputs[0].type === 'hidden' ? inputs[1] : inputs[0];
    }

    if(element !== null) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  submitPayment = () => {
    const inputNames = Object.keys(validationRules);
    const fields = {...this.state.fields};

    const noErrors = this.trySubmit(inputNames, fields);

    return noErrors;
  }

  submitSSG = async() => {
    const ssgCredentials = {...this.state.ssgCredentials};
    const inputNames = Object.keys(ssgCredentials);
    const noErrors = this.trySubmit(inputNames, ssgCredentials, 'login');
    let { submitSSGAttemps, showRecaptcha } = this.state;
    let ssgMemberInfo = {...this.state.ssgMemberInfo};
    let { isLogged, isLogin } = this.state;

    if (noErrors === 0) {

      this.toggleLoader(true);

      const ssgResponse = await DataService.saveSSG(this.state.ssgCredentials);

      ssgMemberInfo = ssgResponse.content;

      submitSSGAttemps++;

      if (submitSSGAttemps === 5) {
        showRecaptcha = true;
        this.toggleRequired(['recaptchaToken'])();
      }

      // read summary to check if ssgOffer from points is valid for this account
      // this is for columbus day sale SSG POINTS promotion
      const summaryResponse = await DataService.readSummary();


      if (summaryResponse.code === 1) {
        this.setState({ summaryResponse: summaryResponse.content });
      }

      const ssgOffer = summaryResponse.content.ssgOffer ? {...summaryResponse.content.ssgOffer} : {};

      // check if ssgOffer comes in readsummary and set promotion true
      const appliesPointsOffer = (Object.keys(ssgOffer).length > 0);
      // END OF CODE FOR PROMOTION

      this.setState({ ssgResponse,
        submitSSGAttemps,
        showRecaptcha,
        ssgMemberInfo,
        appliesPointsOffer,
      });

      // if successful login yet email is not valid lets go to step 4 again and cleanse user's
      // bad input, SSG WHY YOU NOT cleanse user input?
      // https://sanserviceshn.atlassian.net/browse/SOBE-924
      if(ssgResponse.code === 1 && !validator.email.validate(ssgMemberInfo.email.toLowerCase())) {
        window.location = `/guests/?subSessionId=${ window._app.results.subSessionId }`;
      } else

      // cleaning ssg credentials after success.
      if (ssgResponse.code === 1) {

        const { hasInsurance = false } = this.state;

        this._recalculatePrice(hasInsurance, 0);

        isLogin = false;
        isLogged = true;

        this.cleanSSGCredentials(ssgCredentials, inputNames);
        this.setState({ isLogin, isLogged });

      } else if (ssgResponse.code !== 1 && showRecaptcha) {

        this.recaptchaRef.current.reset();

        this.cleanSSGCredentials(ssgCredentials, ['recaptchaToken']);

        validationRules.recaptchaToken = ['required'];
      }

      if (summaryResponse.content.guestsData) {
        const guestsData = summaryResponse.content.guestsData;

        this.setState({ guestsData });
      }

      this.toggleLoader(false);
    }
  }

  cleanSSGCredentials = (ssgCredentials, inputNames) => {

    inputNames.map(field => { ssgCredentials[field] = ''; } );

    this.setState({ ssgCredentials });
  }

  submitSSGRecovery = async(isPassword) => {
    const recoverySSGCredentials = this.state.recoverySSGCredentials;
    const inputNames = Object.keys(recoverySSGCredentials);
    let params = {};
    let fields = {};
    let noErrors = 0;
    let method = '';

    if (isPassword) {
      params = {
        email: recoverySSGCredentials.email_recovery,
        username: recoverySSGCredentials.username_recovery,
      };
      method = 'ssgPasswordRecovery';
      fields = {
        email_recovery: recoverySSGCredentials.email_recovery,
        username_recovery: recoverySSGCredentials.username_recovery
      };
    } else {
      params = {
        email: recoverySSGCredentials.email_recovery,
      };
      method = 'ssgUserRecovery';
      fields = {
        email_recovery: recoverySSGCredentials.email_recovery,
        username_recovery: recoverySSGCredentials.email_recovery
      };
    }

    noErrors = this.trySubmit(inputNames, fields, 'recovery');

    if (noErrors === 0) {

      this.toggleLoader(true);

      const recoverySSGResponse = await DataService[method](params);

      // cleaning state after success.
      if (recoverySSGResponse.code === 1) {
        inputNames.map(field => { recoverySSGCredentials[field] = ''; } );
      }

      this.setState({ recoverySSGCredentials, recoverySSGResponse });
      this.toggleLoader(false);
    }
  }

  logoutSSG = async() => {

    this.toggleLoader(true);

    const ssgResponse = await DataService.logoutSSG();
    let { isLogin, isLogged, ssgMemberInfo, ssgPointsToUse } = this.state;

    isLogin = true;
    isLogged = false;
    ssgMemberInfo = {};
    ssgPointsToUse = 0;

    this.setState({ ssgResponse, ssgMemberInfo, isLogged, isLogin, ssgPointsToUse });
    this.toggleLoader(false);
  }

  areInputFilled() {
    const fields = this.state.fields;
    const totalCards = this.state.totalCards;
    const fieldNames = Object.keys(fields);
    let cc1FieldsFilled = true;
    let cc2FieldsFilled = true;

    fieldNames.forEach((name) => {
      if(name.includes('_1') && name !== 'streetAddress2_1') {
        if(!fields[name]) {
          cc1FieldsFilled = false;
        }
      }

      if(name.includes('_2') && name !== 'streetAddress2_2') {
        if(!fields[name]) {
          cc2FieldsFilled = false;
        }
      }

      if(name === 'termsConditions') {
        if(!fields[name]) {
          cc1FieldsFilled = false;
          cc2FieldsFilled = false;
        }
      }

      if(name.includes('zipCode_1')) {
        const country = fields.country_1;

        switch(country) {
          case 'us':
            cc1FieldsFilled = !fields[name] ? false : true;
            break;
          case 'ca':
            cc1FieldsFilled = !fields[name] ? false : true;
            break;
          case 'gb':
            cc1FieldsFilled = !fields[name] ? false : true;
            break;
          default:
            cc1FieldsFilled = true;
            break;
        }
      }

      if(name.includes('zipCode_2')) {
        const country = fields.country_2;

        switch(country) {
          case 'us':
            cc2FieldsFilled = !fields[name] ? false : true;
            break;
          case 'ca':
            cc2FieldsFilled = !fields[name] ? false : true;
            break;
          case 'gb':
            cc2FieldsFilled = !fields[name] ? false : true;
            break;
          default:
            cc2FieldsFilled = true;
            break;
        }
      }
    });

    if(totalCards === 'twoCards') {
      if(!cc1FieldsFilled || !cc2FieldsFilled) {
        return false;
      }

      return true;
    }


    return cc1FieldsFilled;
  }

  changeUpliftStatus = (status) => {
    const { paymentOption } = this.state.fields;

    if (paymentOption === 'uplift') {
      if(status) {
        this.checkPaymentOption('fullVacation');
      }
    }
  }

  render() {
    const context = {
      state: this.state,
      setLayawayResponse: this.setLayawayResponse,
      setAppliedOffer: this.setAppliedOffer,
      setLoader: this.setLoader,
      setInputValue: this.setInputValue,
      setCCIdValue: this.setCCIdValue,
      setTravelProtectionPlan: this.setTravelProtectionPlan,
      setRecoveryValue: this.setRecoveryValue,
      setSSGState: this.setSSGState,
      resetState: this.resetState,
      zipCodeValidation: this.zipCodeValidation,
      setGuestAddress: this.setGuestAddress,
      setSSGPointsType: this.setSSGPointsType,
      submitPayment: this.submitPayment,
      submitSSGRecovery: this.submitSSGRecovery,
      submitSSG: this.submitSSG,
      logoutSSG: this.logoutSSG,
      getStates: this.getStates,
      setPoints: this.setPoints,
      getFields: this.getFields,
      toggleSSGModal: this.toggleSSGModal,
      toggleRequired: this.toggleRequired,
      toggleLoader: this.toggleLoader,
      trySubmit: this.trySubmit,
      openModal: this.openModal,
      closeModal: this.closeModal,
      setAcceptedTerms: this.setAcceptedTerms,
      paymentOptionsRef: this.paymentOptionsRef,
      amountsRef: this.amountsRef,
      recaptchaRef: this.recaptchaRef,
      areInputFilled: this.areInputFilled,
      changeUpliftStatus: this.changeUpliftStatus,
      setAccountsPassword: this.setAccountsPassword,
      loadAccounts: this.loadAccounts,
    };

    return (
      <PaymentContext.Provider value={context}>
        {this.props.children}
      </PaymentContext.Provider>
    );
  }
}

export { PaymentContext, PaymentProvider };



// WEBPACK FOOTER //
// ./js/components/step5/PaymentContext.js